<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    offset-y
    :min-width="$vuetify.breakpoint.xsOnly ? '100%' : '30rem'"
  >
    <template v-slot:activator="{ on }">
      <v-hover v-slot:default="{ hover }">
        <v-btn icon :color="hover ? 'info' : ''" v-on="on">
          <v-icon>fa-question-circle</v-icon>
        </v-btn>
      </v-hover>
    </template>
    <v-card>
      <v-card-text>
        <HelperSearch ref="helperSearch" v-model="search"></HelperSearch>
        <v-expand-transition>
          <HelperMenuResult
            v-if="search !== ''"
            :value="search"
          ></HelperMenuResult>
        </v-expand-transition>
      </v-card-text>
      <v-card-actions>
        <v-row align="center" justify="end" no-gutters>
          <v-icon x-small left>fa-comment-alt</v-icon>
          <a class="caption" href="mailto:support@geskitchen.com">
            Un problème? Contactez nous à support@geskitchen.com
          </a>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import HelperMenuResult from "./HelperMenuResult";
import HelperSearch from "./HelperSearch";
export default {
  name: "HelperMenu",
  components: {
    HelperSearch,
    HelperMenuResult
  },
  mounted() {
    document.addEventListener("keydown", v => this.openHelpMenu(v));
  },
  data() {
    return {
      search: "",
      menu: false
    };
  },
  methods: {
    openHelpMenu(v) {
      if (v.code === "Backquote") {
        this.menu = !this.menu;
      }
    }
  },
  watch: {
    menu(v) {
      if (v === true) {
        setTimeout(() => this.$refs.helperSearch.focus(), 100);
      } else {
        this.search = "";
      }
    }
  }
};
</script>

<style></style>
